/* unplugin-vue-components disabled */import { render } from "./pblWindow.vue?vue&type=template&id=11d4923d&scoped=true"
import script from "./pblWindow.vue?vue&type=script&lang=js"
export * from "./pblWindow.vue?vue&type=script&lang=js"

import "./pblWindow.vue?vue&type=style&index=0&id=11d4923d&lang=scss&scoped=true"
import "./pblWindow.vue?vue&type=style&index=1&id=11d4923d&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d4923d"]])

export default __exports__